import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'toggle', 'showIcon', 'hideIcon']

  connect () {
    const wrapper = document.createElement('div')
    wrapper.className = 'relative'
    this.inputTarget.parentNode.insertBefore(wrapper, this.inputTarget)
    wrapper.appendChild(this.inputTarget)
    wrapper.appendChild(this.toggleTarget)
    this.toggleTarget.classList.remove('hidden')
  }

  toggle () {
    const isPassword = this.inputTarget.type === 'password'
    this.inputTarget.type = isPassword ? 'text' : 'password'
    this.showIconTarget.classList.toggle('hidden')
    this.hideIconTarget.classList.toggle('hidden')
  }
}
